var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountHis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C8.18889 22 5.73955 21.0683 3.652 19.2048C1.56444 17.3413 0.367481 15.0138 0.061111 12.2222H2.56667C2.85185 14.3407 3.79418 16.0926 5.39367 17.4778C6.99315 18.863 8.86193 19.5556 11 19.5556C13.3833 19.5556 15.4053 18.7257 17.0659 17.0659C18.7265 15.4061 19.5564 13.3841 19.5556 11C19.5547 8.61585 18.7248 6.5943 17.0659 4.93533C15.4069 3.27637 13.385 2.44607 11 2.44444C9.59444 2.44444 8.28055 2.77037 7.05833 3.42222C5.83611 4.07407 4.80741 4.97037 3.97222 6.11111H7.33333V8.55555H0V1.22222H2.44444V4.09444C3.48333 2.79074 4.75159 1.78241 6.24922 1.06944C7.74685 0.356481 9.33044 0 11 0C12.5278 0 13.959 0.290482 15.2937 0.871444C16.6283 1.45241 17.7894 2.23626 18.777 3.223C19.7646 4.20974 20.5488 5.37085 21.1298 6.70633C21.7107 8.04181 22.0008 9.47304 22 11C21.9992 12.527 21.7091 13.9582 21.1298 15.2937C20.5504 16.6291 19.7662 17.7903 18.777 18.777C17.7878 19.7637 16.6267 20.548 15.2937 21.1298C13.9606 21.7116 12.5294 22.0016 11 22ZM14.4222 16.1333L9.77778 11.4889V4.88889H12.2222V10.5111L16.1333 14.4222L14.4222 16.1333Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountHis);
export default __webpack_public_path__ + "static/media/discountHis.4277f49143f5719193f167bfb8d1933f.svg";
export { ForwardRef as ReactComponent };